import React, { useEffect, useState } from "react";
import { useLanguage } from "../../../../Translations/LenguageContext";
import { useParams } from "react-router-dom";
import ErrorMessage from "../../../../Components/ErrorMessage";
import Spinner from "../../../../Components/Spinner";
import { TbGalaxy } from "react-icons/tb";
import AddDomainModal from "./AddDomainModal";
import DeleteDomainModal from "./DeleteDomainModal";

const Domains = ({ show, CloseModal, context }) => {
    const { t } = useLanguage();
    const { project_id } = useParams();
    const user_id = sessionStorage.getItem("user_id");
    const [loadingRules, setLoadingRules] = useState(true);
    const [error, setError] = useState({ message: "", display: false });
    const [erioonFrontend, setErioonFrontend] = useState(null);
    const [erioonBackend, setErioonBackend] = useState(null);
    const [erioonApi, setErioonApi] = useState(null)
    const [herokuFrontend, setHerokuFrontend] = useState(null);
    const [herokuBackend, setHerokuBackend] = useState(null);
    const [herokuApi, setHerokuApi] = useState(null);
    const [customFrontend, setCustomFrontend] = useState({});
    const [customBackend, setCustomBackend] = useState({});
    const [customApi, setCustomApi] = useState({});
    const [showAddDomain, setShowAddDomain] = useState(false)
    const [copiedDomain, setCopiedDomain] = useState(null);
    const [loadingCert, setLoadingCert] = useState(false)
    const [openDeleteDomain, setOpenDeleteDomain] = useState(false)
    const [domainDelete, setDomainDelete] = useState(null)
    const [domainType, setDomainType] = useState(null)
    const [certCheck, setCertCheck] = useState(false)

    const GetDomains = async () => {
        setLoadingRules(true);
        try {
            const response = await fetch("https://aiservice.erioon.com/get_title_description_codebase", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    user_id,
                    project_id
                }),
            });
            if (response.ok) {
                const result = await response.json();
                const frontendUrls = result.frontend_url;
                const backendUrls = result.backend_url;
                const apiUrls = result.api_url;

                setHerokuFrontend(frontendUrls.heroku);
                setHerokuBackend(backendUrls.heroku);
                setErioonFrontend(frontendUrls.erioon);
                setErioonBackend(backendUrls.erioon);
                setCustomFrontend(frontendUrls.custom);
                setCustomBackend(backendUrls.custom);

                setHerokuApi(apiUrls.heroku);
                setErioonApi(apiUrls.erioon);
                setCustomApi(apiUrls.custom);

                setError({ message: "", display: false });
            } else {
                setError({ message: "Failed to connect to the server. Please try again later.", display: true });
            }
        } catch (err) {
            setError({ message: "Failed to connect to the server. Please try again later.", display: true });
        } finally {
            setTimeout(() => {
                setLoadingRules(false);
            }, 800);
        }
    };

    const AddSSL = async () => {
        setLoadingCert(true);
        setError({ message: "", display: false });
        const data = { user_id, project_id };

        try {
            const response = await fetch("https://aiservice.erioon.com/add_ssl_cert", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                setError({ message: "", display: false });
                setCertCheck(true)
            } else {
                setError({ message: `Domain is not available`, display: true });
            }
        } catch (err) {
            setLoadingCert(false);
            setError({ message: "Failed to save AI settings. Please try again later.", display: true });
        } finally {
            setLoadingCert(false);
            setTimeout(() => {
                setCertCheck(false)
            }, 2000);
        }
    };

    const DeleteDomain = (domain, type) => {
        setDomainDelete(domain)
        setDomainType(type)
        setOpenDeleteDomain(true)
    }

    useEffect(() => {
        if (show) {
            GetDomains();
        }
    }, [show]);

    const handleCopy = (domain) => {
        navigator.clipboard.writeText(domain);
        setCopiedDomain(domain);
        setTimeout(() => setCopiedDomain(null), 2000);
    };

    const addDomain = () => {
        setShowAddDomain(true)
    }

    return (
        <div className="ai_settings_cont_modal_inner">
            {loadingRules ? (
                <div className="loading_fetch_preview">
                    <div className="loading_logo_erioon">
                        <p className="loading_logo_erioon_icon">
                            <i>
                                <TbGalaxy />
                            </i>
                        </p>
                    </div>
                </div>
            ) : (

                context == "webapp" ? (

                    herokuFrontend ? (
                        <div>
                            {/* <p className="share_label">Domains</p>
                        <p className="share_label_desc">
                            Add and manage custom domains to make your project accessible on your own URL.
                        </p> */}


                            <p className="columns_section_title">Frontend domains</p>
                            <div className="default_domains">
                                {herokuFrontend && (
                                    <p className="default_domain" onClick={() => handleCopy(herokuFrontend)}>
                                        Default - {herokuFrontend}
                                    </p>
                                )}

                                {erioonFrontend && (
                                    <p className="default_domain" onClick={() => handleCopy(erioonFrontend)}>
                                        Default - {erioonFrontend}
                                    </p>
                                )}
                            </div>
                            {customFrontend && Object.keys(customFrontend).length > 0 ? (
                                <div className="available_domains">
                                    <div className="dns_cont_record_table fade-in">
                                        <div className="dns_cont_record">
                                            <div className="dns_cont_record_cell_first dns_cont_header_cell">Type</div>
                                            <div className="dns_cont_record_cell_third dns_cont_header_cell">Domain</div>
                                            <div className="dns_cont_record_cell_second dns_cont_header_cell">Value</div>
                                            <div className="dns_cont_record_cell_first dns_cont_header_cell"></div>
                                        </div>

                                        {Object.entries(customFrontend).map(([key, value]) => (
                                            value.dns && (
                                                <div key={key} className="dns_cont_record">
                                                    <div className="dns_cont_record_cell_first">CNAME</div>
                                                    <div className="dns_cont_record_cell_third">{value.domain}</div>
                                                    <div className="dns_cont_record_cell_second">{value.dns}</div>
                                                    <div className="dns_cont_record_cell_first">
                                                        <button className="domains_btn" onClick={() => DeleteDomain(value.domain, "frontend")}><i className="fa-solid fa-trash"></i></button>
                                                    </div>
                                                </div>
                                            )
                                        ))}
                                    </div>

                                </div>
                            ) : (
                                <p className="no_custom_domains">No custom frontend domains available</p>
                            )}


                            <p className="columns_section_title">Backend domains</p>
                            <div className="default_domains">
                                {herokuBackend && (
                                    <p className="default_domain" onClick={() => handleCopy(herokuBackend)}>
                                        Default - {herokuBackend}
                                    </p>
                                )}

                                {erioonBackend && (
                                    <p className="default_domain" onClick={() => handleCopy(erioonBackend)}>
                                        Default - {erioonBackend}
                                    </p>
                                )}
                            </div>
                            {customBackend && Object.keys(customBackend).length > 0 ? (
                                <div className="available_domains">
                                    <div className="dns_cont_record_table fade-in">
                                        <div className="dns_cont_record">
                                            <div className="dns_cont_record_cell_first dns_cont_header_cell">Type</div>
                                            <div className="dns_cont_record_cell_third dns_cont_header_cell">Domain</div>
                                            <div className="dns_cont_record_cell_second dns_cont_header_cell">Value</div>
                                            <div className="dns_cont_record_cell_first dns_cont_header_cell"></div>
                                        </div>

                                        {Object.entries(customBackend).map(([key, value]) => (
                                            value.dns && (
                                                <div key={key} className="dns_cont_record">
                                                    <div className="dns_cont_record_cell_first">CNAME</div>
                                                    <div className="dns_cont_record_cell_third">{value.domain}</div>
                                                    <div className="dns_cont_record_cell_second">{value.dns}</div>
                                                    <div className="dns_cont_record_cell_first">
                                                        <button className="domains_btn" onClick={() => DeleteDomain(value.domain, "backend")}>
                                                            <i className="fa-solid fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            )
                                        ))}
                                    </div>

                                </div>
                            ) : (
                                <p className="no_custom_domains">No custom backend domains available</p>
                            )}

                            <p className="columns_section_subtitle"><strong>It may take a few moments for a newly added domains to fully propagate.</strong></p>
                            <p className="columns_section_title">Certificates</p>
                            <p className="columns_section_subtitle">
                                Certificates are automatically generated each time you add a domain.
                                You can also reset them with a single click.
                            </p>

                            <button className="add_custom_domain_btn" onClick={AddSSL}>
                                {loadingCert ? (
                                    <Spinner loading={loadingCert} />
                                ) : (
                                    <>
                                        {certCheck ? (
                                            <i className="fa-solid fa-check"></i>
                                        ) : (
                                            <>Reset SSL certificates</>
                                        )}
                                    </>
                                )}
                            </button>

                            <div className="ai_settings_cont_modal_footer">
                                <ErrorMessage err={error} />
                                <div className="footer_btn_cont">
                                    <button className="save_btn" onClick={addDomain}>
                                        Add domain
                                    </button>
                                    <button className="cancel_btn" onClick={CloseModal}>
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="preview_main_container_body_empty">
                            <p className="preview_main_container_body_empty_title">No domains available</p>
                            <p className="preview_main_container_body_empty_desc">
                                All domains will appear here once you publish your project.
                            </p>

                            <div className="preview_canvas_cont">
                                <div className="preview_items_cont">
                                    <div className="preview_items_cont_item_one">https://www.your-domain.com</div>
                                </div>
                            </div>
                            <div className="ai_settings_cont_modal_footer">
                                <ErrorMessage err={error} />
                                <div className="footer_btn_cont">
                                    <button className="cancel_btn" onClick={CloseModal}>
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                ): context == "serverless" ? (

                    herokuFrontend ? (
                        <div>
                            {/* <p className="share_label">Domains</p>
                        <p className="share_label_desc">
                            Add and manage custom domains to make your project accessible on your own URL.
                        </p> */}


                            <p className="columns_section_title">Frontend domains</p>
                            <div className="default_domains">
                                {herokuFrontend && (
                                    <p className="default_domain" onClick={() => handleCopy(herokuFrontend)}>
                                        Default - {herokuFrontend}
                                    </p>
                                )}

                                {erioonFrontend && (
                                    <p className="default_domain" onClick={() => handleCopy(erioonFrontend)}>
                                        Default - {erioonFrontend}
                                    </p>
                                )}
                            </div>
                            {customFrontend && Object.keys(customFrontend).length > 0 ? (
                                <div className="available_domains">
                                    <div className="dns_cont_record_table fade-in">
                                        <div className="dns_cont_record">
                                            <div className="dns_cont_record_cell_first dns_cont_header_cell">Type</div>
                                            <div className="dns_cont_record_cell_third dns_cont_header_cell">Domain</div>
                                            <div className="dns_cont_record_cell_second dns_cont_header_cell">Value</div>
                                            <div className="dns_cont_record_cell_first dns_cont_header_cell"></div>
                                        </div>

                                        {Object.entries(customFrontend).map(([key, value]) => (
                                            value.dns && (
                                                <div key={key} className="dns_cont_record">
                                                    <div className="dns_cont_record_cell_first">CNAME</div>
                                                    <div className="dns_cont_record_cell_third">{value.domain}</div>
                                                    <div className="dns_cont_record_cell_second">{value.dns}</div>
                                                    <div className="dns_cont_record_cell_first">
                                                        <button className="domains_btn" onClick={() => DeleteDomain(value.domain, "frontend")}><i className="fa-solid fa-trash"></i></button>
                                                    </div>
                                                </div>
                                            )
                                        ))}
                                    </div>

                                </div>
                            ) : (
                                <p className="no_custom_domains">No custom frontend domains available</p>
                            )}


                           

                            <p className="columns_section_subtitle"><strong>It may take a few moments for a newly added domains to fully propagate.</strong></p>
                            <p className="columns_section_title">Certificates</p>
                            <p className="columns_section_subtitle">
                                Certificates are automatically generated each time you add a domain.
                                You can also reset them with a single click.
                            </p>

                            <button className="add_custom_domain_btn" onClick={AddSSL}>
                                {loadingCert ? (
                                    <Spinner loading={loadingCert} />
                                ) : (
                                    <>
                                        {certCheck ? (
                                            <i className="fa-solid fa-check"></i>
                                        ) : (
                                            <>Reset SSL certificates</>
                                        )}
                                    </>
                                )}
                            </button>

                            <div className="ai_settings_cont_modal_footer">
                                <ErrorMessage err={error} />
                                <div className="footer_btn_cont">
                                    <button className="save_btn" onClick={addDomain}>
                                        Add domain
                                    </button>
                                    <button className="cancel_btn" onClick={CloseModal}>
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="preview_main_container_body_empty fade-in">
                            <p className="preview_main_container_body_empty_title">No domains available</p>
                            <p className="preview_main_container_body_empty_desc">
                                All domains will appear here once you publish your project.
                            </p>

                            <div className="preview_canvas_cont">
                                <div className="preview_items_cont">
                                    <div className="preview_items_cont_item_one">https://www.your-domain.com</div>
                                </div>
                            </div>
                            <div className="ai_settings_cont_modal_footer">
                                <ErrorMessage err={error} />
                                <div className="footer_btn_cont">
                                    <button className="cancel_btn" onClick={CloseModal}>
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                ) : context == "api" ? (
                    herokuApi ? (
                        <div>
                            {/* <p className="share_label">Domains</p>
                        <p className="share_label_desc">
                            Add and manage custom domains to make your project accessible on your own URL.
                        </p> */}


                            <p className="columns_section_title">API domains</p>
                            <div className="default_domains">
                                {herokuApi && (
                                    <p className="default_domain" onClick={() => handleCopy(herokuApi)}>
                                        Default - {herokuApi}
                                    </p>
                                )}

                                {erioonApi && (
                                    <p className="default_domain" onClick={() => handleCopy(erioonApi)}>
                                        Default - {erioonApi}
                                    </p>
                                )}
                            </div>
                            {customApi && Object.keys(customApi).length > 0 ? (
                                <div className="available_domains">
                                    <div className="dns_cont_record_table fade-in">
                                        <div className="dns_cont_record">
                                            <div className="dns_cont_record_cell_first dns_cont_header_cell">Type</div>
                                            <div className="dns_cont_record_cell_third dns_cont_header_cell">Domain</div>
                                            <div className="dns_cont_record_cell_second dns_cont_header_cell">Value</div>
                                            <div className="dns_cont_record_cell_first dns_cont_header_cell"></div>
                                        </div>

                                        {Object.entries(customApi).map(([key, value]) => (
                                            value.dns && (
                                                <div key={key} className="dns_cont_record">
                                                    <div className="dns_cont_record_cell_first">CNAME</div>
                                                    <div className="dns_cont_record_cell_third">{value.domain}</div>
                                                    <div className="dns_cont_record_cell_second">{value.dns}</div>
                                                    <div className="dns_cont_record_cell_first">
                                                        <button className="domains_btn" onClick={() => DeleteDomain(value.domain, "frontend")}><i className="fa-solid fa-trash"></i></button>
                                                    </div>
                                                </div>
                                            )
                                        ))}
                                    </div>

                                </div>
                            ) : (
                                <p className="no_custom_domains">No custom API domains available</p>
                            )}

                            <p className="columns_section_subtitle"><strong>It may take a few moments for a newly added domains to fully propagate.</strong></p>
                            <p className="columns_section_title">Certificates</p>
                            <p className="columns_section_subtitle">
                                Certificates are automatically generated each time you add a domain.
                                You can also reset them with a single click.
                            </p>

                            <button className="add_custom_domain_btn" onClick={AddSSL}>
                                {loadingCert ? (
                                    <Spinner loading={loadingCert} />
                                ) : (
                                    <>
                                        {certCheck ? (
                                            <i className="fa-solid fa-check"></i>
                                        ) : (
                                            <>Reset SSL certificates</>
                                        )}
                                    </>
                                )}
                            </button>

                            <div className="ai_settings_cont_modal_footer">
                                <ErrorMessage err={error} />
                                <div className="footer_btn_cont">
                                    <button className="save_btn" onClick={addDomain}>
                                        Add domain
                                    </button>
                                    <button className="cancel_btn" onClick={CloseModal}>
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="preview_main_container_body_empty">
                            <p className="preview_main_container_body_empty_title">No domains available</p>
                            <p className="preview_main_container_body_empty_desc">
                                All domains will appear here once you publish your project, a.
                            </p>

                            <div className="preview_canvas_cont">
                                <div className="preview_items_cont">
                                    <div className="preview_items_cont_item_one">https://www.your-domain.com</div>
                                </div>
                            </div>
                            <div className="ai_settings_cont_modal_footer">
                                <ErrorMessage err={error} />
                                <div className="footer_btn_cont">
                                    <button className="cancel_btn" onClick={CloseModal}>
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                ):(
                    <></>
                )
            )}

            <AddDomainModal
                showAddDomain={showAddDomain}
                closeAddDomain={() => setShowAddDomain(false)}
                GetDomains={GetDomains}
                context={context}
            />

            <DeleteDomainModal
                showDeleteDomain={openDeleteDomain}
                closeDeleteDomains={() => setOpenDeleteDomain(false)}
                GetDomains={GetDomains}
                domainDelete={domainDelete}
                domainType={domainType}
            />

        </div>
    );
};

export default Domains;
